import AgGridWrapper from "../../../../../components/AgGridWrapper/AgGridWrapper";
import ActionButtons from "../../../../../components/ActionButtons";
import { changeStatus, setGrid } from "../../utils/slice";
import { useMemo, useState } from "react";
import ConfirmModal from "../../../../../components/Modals/ConfirmModal";
import useColumnDefs from "./useColumnDefs";
import { useAppSelector } from "../../../../../utils/hooks/hooks";
import { RootState } from "../../../../../store/app";

/**
 * Renders the Listing component for UserManagement module.
 *
 * @param {Object} props - The component props.
 * @param {Object} props.moduleInfo - Information about the module.
 * @param {Function} props.handleViewInterestAssessmentClick - The click event handler for viewing Interest Discovery details.
 * @param {Function} props.handleViewSkillAssessmentClick - The click event handler for viewing Skill Portrait details.
 * @param {Function} props.handleViewAssessmentResultClick - The click event handler for viewing Career Compass result details.
 * @param {Function} props.handleViewClick - The click event handler for viewing details of a user profile.
 * @param {Function} props.handleDeleteClick - The click event handler for deleting a user profile.
 * @param {Function} props.handleEditClick - The click event handler for editing user profile.
 * @return {JSX.Element} The rendered Listing component.
 */
const Listing: React.FC<any> = ({
  moduleInfo,
  handleViewInterestAssessmentClick,
  handleViewSkillAssessmentClick,
  handleViewAssessmentResultClick,
  handleExamDetailsClick,
  handleViewClick,
  handleDeleteClick,
  handleEditClick,
  handleChangePassword
}) => {
  const columnDefs = useMemo(useColumnDefs, []);
  const [statusData, setStatusData] = useState<any>();
  const user = useAppSelector((state: RootState) => state.user);
  const ActionRenderer = (props: any) => {

    return (
      <ActionButtons
        data={props}
        checkid={props.data.id}
        // viewInterestAssessment={{
        //   action: [1,2].includes(exam_status) ? handleViewInterestAssessmentClick : false,
        //   permissionKey: `${moduleInfo.permissionKeyPrefix}_DETAILS`,
        // }}
        // viewSkillAssessment={{
        //   action: [2].includes(exam_status) ? handleViewSkillAssessmentClick : false,
        //   permissionKey: `${moduleInfo.permissionKeyPrefix}_DETAILS`,
        // }}
        // viewAssessmentResult={{
        //   action: [2].includes(exam_status) ? handleViewAssessmentResultClick : false,
        //   permissionKey: `${moduleInfo.permissionKeyPrefix}_DETAILS`,
        // }}
        viewExamDetails={{
          action: handleExamDetailsClick,
          permissionKey: `${moduleInfo.permissionKeyPrefix}_DETAILS`,
        }}
        view={{
          action: handleViewClick,
          permissionKey: `${moduleInfo.permissionKeyPrefix}_DETAILS`,
        }}
        edit={{
          action: handleEditClick,
          permissionKey: `${moduleInfo.permissionKeyPrefix}_UPDATE`,
        }}
        deleteButton={{
          action: handleDeleteClick,
          permissionKey: `${moduleInfo.permissionKeyPrefix}_DELETE`,
        }}
        changePassword={{
          action: handleChangePassword,
          permissionKey: `${moduleInfo.permissionKeyPrefix}_UPDATE`,
        }}
      />
    );
  };

  return (
    <>
      <ConfirmModal
        titleName={moduleInfo.title}
        data={statusData}
        close={() => setStatusData(null)}
        callApi={changeStatus}
      />
      <AgGridWrapper
        components={{
          ActionRenderer,
        }}
        rowData={user.rowData}
        onGridReadyWithDispatch={setGrid}
        columnDefs={columnDefs}
        context={{ setStatusData }}
        paginationPageSize={user.perPage}
        cacheBlockSize={user.perPage}
      />
    </>
  );
};

export default Listing;
